import { render, staticRenderFns } from "./courseDetail.vue?vue&type=template&id=b56a5868&scoped=true"
import script from "./courseDetail.vue?vue&type=script&lang=js"
export * from "./courseDetail.vue?vue&type=script&lang=js"
import style0 from "./courseDetail.vue?vue&type=style&index=0&id=b56a5868&lang=less&scoped=true"
import style1 from "./courseDetail.vue?vue&type=style&index=1&id=b56a5868&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b56a5868",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b56a5868')) {
      api.createRecord('b56a5868', component.options)
    } else {
      api.reload('b56a5868', component.options)
    }
    module.hot.accept("./courseDetail.vue?vue&type=template&id=b56a5868&scoped=true", function () {
      api.rerender('b56a5868', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/login/courseDetail.vue"
export default component.exports